import { FailureTypeVm } from "api/generated/lumen";
import { FailureListRequestParams } from "features/failures/models";
import { GetFilterParamsForGetRequests } from "models/common";
import { calculateFilterRequestParams } from "utils";
import {
  ListRequestParams,
  mergeListParams,
} from "widgets/table/useTableUtils";

export const getFilterParamsForFailureTypesGetRequests = (
  params: FailureListRequestParams,
  existingParams: FailureListRequestParams
): GetFilterParamsForGetRequests => {
  const mergedParams = mergeListParams(existingParams, params);

  const filter = calculateFilterRequestParams<FailureTypeVm>(mergedParams, {
    tasks: (value) => (value ? [value] : undefined),
  });

  const payload: ListRequestParams = {
    ...mergedParams,
    filter,
  };

  return { payload, mergedParams };
};
